import { DocumentTemplateFormPage } from "pages/masters/DocumentTemplateFormPage";
import * as React from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

import { LoginPage } from "../components/LoginPage";
import { ForgotPasswordPage } from "../components/ForgotPasswordPage";
import { DashboardLayoutNew } from "../components/DashboardLayoutNew";

import { DashboardPage } from "../pages/DashboardPage";
import { MannatNiyazReceiptPage } from "../pages//mannatNiyaz/MannatNiyazReceipt/MannatNiyazReceiptPage";
import { MannatNiyazDashboardPage } from "../pages/mannatNiyaz/MannatNiyazDashboardPage";
// import { MannatNiyazReceiptViewPage } from "../pages/mannatNiyaz/MannatNiyazReceipt/MannatNiyazReceiptViewPage";
import { RoleManagementPage } from "../pages/system-administration/RoleManagementPage";
import { UserManagementPage } from "../pages/system-administration/UserManagementPage";
import { RequestUserPage } from "../pages/system-administration/RequestUserPage";
import { EmailConfigPage } from "../pages/system-administration/EmailConfigPage";
import { CountryCityMasterPage } from "../pages/masters/CountryCityMasterPage";
import { DocumentMasterPage } from "../pages/masters/DocumentMasterPage";
import { VenueMasterEnhanced } from "../pages/masters/venueMaster/VenueMasterEnhanced";
import { TourOperatorType } from "../pages/masters/TourOperatorType";
import { GeneralMasterPage } from "../pages/masters/GeneralMasterPage";
import { CutoffMasterPage } from "../pages/masters/CutoffMasterPage";
import { NationalityMasterPage } from "../pages/masters/NationalityMasterPage";
import { TORegistrationPage } from "../public/TORegistrationPage";
import { AgeRuleMasterPage } from "../pages/masters/AgeRuleMasterPage";
import { VisaFeeMasterPage } from "../pages/masters/VisaFeeMasterPage";
import VisaApplicantAddPage from "../pages/muwafiqa/visa/VisaApplicantAddPage";
import { EnhancedMuwafiqaProcessingPage } from "../pages/muwafiqa/EnhancedMuwafiqaProcessingPage";

import { TourServiceMasterPage } from "../pages/masters/TourServiceMasterPage";
import { CurrencyMasterPage } from "../pages/masters/CurrencyMasterPage";
import TORegistrationManagementDashboard from "../pages/tour-registration/TORegistrationManagementDashboard";
import { TORegistrationAdminPage } from "../pages/tour-registration/TORegistrationAdminPage";

import { AdvanceReceiptListPage } from "../pages/finance/AdvanceReceiptListPage";
import { AdvanceReceiptFormPage } from "../pages/finance/AdvanceReceiptFormPage";
import { TOLedgerWalletFinance } from "../pages/finance/TOLedgerWalletFinance";

import VisaApplicantViewPage from "../pages/muwafiqa/visa/VisaApplicantViewPage";
import VisaApplicantMoreInfoViewPage from "../pages/muwafiqa/visa/VisaApplicantMoreInfoViewPage";
import VisaApplicantEditPage from "../pages/muwafiqa/visa/VisaApplicantEditPage";
import TORegistrationRenewalList from "../pages/tour-registration/TORegistrationRenewalList";
import { BlockUsersMasterPage } from "../pages/tour-registration/BlockUsersMasterPage";
import RenewalApprovalDetailsPage from "../pages/tour-registration/RenewalApprovalDetailsPage";
import { VisaApplicantManagementPage } from "../pages/muwafiqa/visa/VisaApplicantManagementPageNew";

import { CompletedListPage } from "../pages/muwafiqa/completed/CompletedListPage";
import { CompletedApplicationViewPage } from "../pages/muwafiqa/completed/CompletedApplicationViewPage";
import { VisaRequestedPageNew } from "../pages/muwafiqa/visaRequested/VisaRequestedPageNew";
import { VisaApplicantDetailPage } from "../pages/muwafiqa/visaRequested/VisaApplicantDetailPage";
import { TORegistrationReviewPage } from "../pages/tour-registration/ToReviewPage";

import { PortMasterFormPage } from "../pages/masters/portMaster/PortMasterFormPage";
import { PortMasterListPage } from "../pages/masters/portMaster/PortMasterListPage";
import { LawazimTypeMasterPage } from "../pages/masters/lawazimMaster/LawazimTypeMasterPage";
import { PropertyTypeGradeMasterPage } from "../pages/masters/accommodationMaster/PropertyTypeGradeMasterPage";
import { PropertyGradeMaster } from "../pages/masters/accommodationMaster/PropertyGradeMaster";
import { RoomAmenitiesMasterPage } from "pages/masters/accommodationMaster/RoomAmenitiesMasterPage";
import { RoomTypeMasterPage } from "pages/masters/accommodationMaster/RoomTypeMasterPage";
import { PropertyDetailsMasterPage } from "pages/masters/accommodationMaster/propertyDetails/PropertyDetailsMasterPage";
import { AddPropertyPage } from "pages/masters/accommodationMaster/propertyDetails/AddPropertyPage";
import { CurrencyHeadMasterPage } from "pages/mannatNiyaz/CurrencyHeadMasterPage";
import { BufferConfigurationMaster } from "pages/masters/BufferConfigurationMaster";
import { WarehouseMasterPage } from "pages/masters/WarehouseMaster";
import TourListPageEnhanced from "pages/tours/TourListPageEnhanced";
import CreateTourMiqqaatPage from "pages/tours/CreateTourMiqaatPage";
import { IntercityCheckoutPage } from "pages/masters/IntercityCheckoutPage";
import { EmployeeListPage } from "pages/hr/EmployeeListPage";
import { EmployeeFormPage } from "pages/hr/EmployeeFormPage";
import { SalaryHeadsPage } from "pages/hr/SalaryHeadPage";
import { TourCreationDashboardPage } from "pages/tours/TourCreationDashboardPage";
import ManageDepartmentPage from "pages/hr/ManageDepartmentPage";
import DesignationMasterPage from "pages/hr/DesignationMasterPage";
import { WorkflowMasterPage } from "pages/workflow/WorkflowMasterPage";
import InstantBookingTourPage from "pages/tours/InstantBooking/InstantBookingTourPage";
import { PropertyAvailabilityMasterPage } from "pages/masters/accommodationMaster/PropertyAvailability/PropertyAvailabilityMasterPage";
import AvailabilityAdd from "pages/masters/accommodationMaster/PropertyAvailability/Availability/AvailabilityAdd";
import AvailabilityEdit from "pages/masters/accommodationMaster/PropertyAvailability/Availability/AvailabilityEdit";
import BlockPropertyAdd from "pages/masters/accommodationMaster/PropertyAvailability/BlockProperty/BlockPropertyAdd";
import BlockPropertyEdit from "pages/masters/accommodationMaster/PropertyAvailability/BlockProperty/BlockPropertyEdit";
// import TourApprovalView from "pages/tours/TourViewEdit/TourApprovalView";
import TourViewEditPage from "pages/tours/TourViewEdit/TourViewEditPage";
import TourApprovalView from "pages/tours/TourViewEdit/TourApprovalView/TourApprovalView";
import TourRecommendChanges from "pages/tours/TourViewEdit/TourApprovalView/TourRecommendChanges";
import WalkInTourCreatePage from "pages/tours/WalkInTour/WalkInTourCreatePage";
import { VehicleTypeMasterPage } from "pages/masters/transportMaster/VehicleTypeMasterPage";
import { VehicleMasterPage } from "pages/masters/transportMaster/VehicleMasterPage";
import { VendorMasterPage } from "pages/masters/transportMaster/VendorMasterPage";
import { TransportDashboardPage } from "pages/transport/TransportDashboardPage";
import WalkinTourListPageEnhanced from "pages/tours/WalkInTour/WalkinTourListPageEnhanced";
import WalkInTourViewEditPage from "pages/tours/WalkInTour/WalkInTourViewEditPage";
import { VendorDashboardPage } from "pages/transport/VendorDashboardPage";
import { EmployeeTypesPage } from "pages/hr/EmployeeTypesPage";
import { EmployeeGradesPage } from "pages/hr/EmployeeGradesPage";
import { EmploymentStatusPage } from "pages/hr/EmploymentStatusPage";
import { BookingReceiptListPage } from "../pages/finance/BookingReceiptListPage";
import { BookingReceiptFormPage } from "../pages/finance/BookingReceiptFormPage";
import { MenuCalendarPage } from "pages/mawaid/MenuCalendarPage";

import { VerifyOtpPage } from "../components/VerifyOtpPage";
import NotFoundPage from "../pages/NotFoundPage";
import PermissionRoute from "./PermissionRoute";
import { ModuleProvider } from "../contexts/ModuleContext";
import { MiqaatConfiguration } from "../pages/masters/miqaatMaster/MiqaatConfiguration";
import { AddMiqaatConfiguration } from "../pages/masters/miqaatMaster/AddMiqaatConfiguration";
import { EditMiqaatConfiguration } from "../pages/masters/miqaatMaster/EditMiqaatConfiguration";
import { LawazimConfiguration } from "../pages/masters/lawazimConfig/LawazimConfiguration";
import { AddLawazimConfiguration } from "../pages/masters/lawazimConfig/AddLawazimConfiguration";
import { EditLawazimConfiguration } from "../pages/masters/lawazimConfig/EditLawazimConfiguration";
import { ZiyaratPlacesMasterPage } from "pages/ziyarat/ZiyaratPlacesMasterPage";
import { ZiyaratAtraafRoutesMaster } from "pages/ziyarat/Atraaf/ZiyaratAtraafRoutesMaster";
import { CreateZiyaratAtraafRoutePage } from "pages/ziyarat/Atraaf/CreateZiyaratAtraafRoutePage";
import { EditZiyaratAtraafRoutePage } from "pages/ziyarat/Atraaf/EditZiyaratAtraafRoutePage";
// import { VenueApprovalPageEnhanced } from "pages/tours/venueApproval/VenueApprovalPageEnhanced";
import TourApprovalPage from "pages/tours/tourApproval/TourApprovalPage";
import TourApprovalViewPage from "pages/tours/tourApproval/TourApprovalViewPage";
import QarzanHassanaPage from "pages/hr/QarzanHassanaPage";
import LeaveTypeMasterPage from "pages/hr/LeaveTypeMasterPage";
import TORegistrationDashboardPage from "pages/tour-registration/TORegistrationDashboardPage";
import { MyRegistrationReviewPage } from "pages/tour-registration/MyTORegistrationReviewPage";
// import { PlaceholderPageDetail } from "../pages/qarz/PlaceholderPage";
import { QarzLoanRegisterPage } from "../pages/qarz/QarzLoanRegisterPage";
import { QarzanHasanaFormPage } from "../pages/qarz/QarzanHasanaFormPage";
import { QarzanHasanaFormEditPage } from "pages/qarz/QarzanHasanaFormEditPage";
import { VenueApprovalListPage } from "pages/tours/venueApproval/VenueApprovalListPage";
import { VenueApprovalViewPage } from "pages/tours/venueApproval/VenueApprovalViewPage";
import { AccommodationDashboardEnhanced } from "pages/accommodation/AccommodationDashboardEnhanced";
import { AccommodationReportsPage } from "pages/accommodation/AccommodationReportsPage";
import { AccountProfilePage } from "pages/account/AccountProfilePage";
import { AccommodationReportsCheckInPage } from "pages/accommodation/AccommodationReportsCheckinPage";
import { LuggageTagAutomationPage } from "pages/accommodation/LuggageTagAutomationPage";
import { AtraafRoutePlannerPage } from "pages/ziyarat/AtraafRoutePlannerPage";
import { HolidaysMasterPage } from "pages/hr/HolidaysPage";
// import { LeaveStructuresMasterPage } from "pages/hr/LeaveStructuresPage";
import { PayrollPage } from "pages/hr/PayrollPage";
import { LeaveStructuresPage } from "pages/hr/LeaveStructuresPage";
import { LeavePolicyDetailsPage } from "pages/hr/LeavePolicyDetailsPage";
import { DocumentTemplateMasterPage } from "pages/masters/DocumentTemplateMasterPage";
import { QardanPolicyPage } from "pages/hr/QardanPolicyPage";
import { MenuMasterPage } from "pages/mawaid/MenuMasterPage";
import { MawaidDashboardPage } from "pages/mawaid/MawaidDashboardPage";
import { AttendancePage } from "pages/hr/AttendancePage";

/* ✅ Protected route wrapper */
const ProtectedRoute = ({ children }: { children: React.JSX.Element }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-sky-700 font-medium">
        Loading...
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const ProtectedLayout = ({ children }: { children: React.ReactNode }) => (
  <ProtectedRoute>
    <ModuleProvider>{children}</ModuleProvider>
  </ProtectedRoute>
);

const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPage, setCurrentPage] = React.useState("dashboard");

  const { isAuthenticated } = useAuth();

  React.useEffect(() => {
    const path = location.pathname.split("/").pop() || "dashboard";

    // If we're on the print view page, clear sidebar highlight
    if (path === "mannat-receipt-view") {
      setCurrentPage("");
    } else {
      setCurrentPage(path);
    }
  }, [location]);

  // const handleNavigate = (path: string) => {
  //     setCurrentPage(path);
  //     navigate(path === "dashboard" ? "/dashboard" : `/${path}`);
  // };

  const handleNavigate = (path: string) => {
    setCurrentPage(path);

    // If path already starts with "/", use it as-is
    if (path.startsWith("/")) {
      navigate(path);
    } else {
      navigate(path === "dashboard" ? "/dashboard" : `/${path}`);
    }
  };

  return (
    <Routes>
      {/* ---------- Public Routes ---------- */}
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordPage onBackToLogin={() => navigate("/")} />}
      />

      <Route
        path="/to-registration"
        element={<TORegistrationPage onBack={() => navigate("/")} />}
        // element={<TORegistrationPage onBack={function (): void {
        //     throw new Error("Function not implemented.");
        // } }  />}
      />

      <Route
        path="/verify-otp"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <VerifyOtpPage />
          )
        }
      />

      {/* ---------- Protected Routes ---------- */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage={currentPage}
              onNavigate={handleNavigate}
            >
              <DashboardPage />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      {/* TOUR REGISTRATION ROUTES */}
      <Route
        path="/profile"
        element={
          <ProtectedLayout>
            <DashboardLayoutNew
              currentPage="profile"
              onNavigate={handleNavigate}
            >
              <AccountProfilePage />
            </DashboardLayoutNew>
          </ProtectedLayout>
        }
      />

      <Route
        path="/registration"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration"
                onNavigate={handleNavigate}
              >
                <TORegistrationManagementDashboard
                  onNavigate={handleNavigate}
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/registration/list"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration"
                onNavigate={handleNavigate}
              >
                <TORegistrationAdminPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* venue approval  */}
      <Route
        path="/tour-approval"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tour-approval"
                onNavigate={handleNavigate}
              >
                <TourApprovalPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tour-approval-view/:id"
        element={
          <DashboardLayoutNew
            currentPage="tour-approval"
            onNavigate={handleNavigate}
          >
            <TourApprovalViewPage onNavigate={handleNavigate} />
          </DashboardLayoutNew>
        }
      />

      {/* <Route
        path="/venue-approval"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="venue-approval"
                onNavigate={handleNavigate}
              >
                <VenueApprovalPageEnhanced onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      /> */}

      <Route
        path="/venue-approval"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="venue-approval"
                onNavigate={handleNavigate}
              >
                <VenueApprovalListPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/venue-approval/view/:tourId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="venue-approval"
                onNavigate={handleNavigate}
              >
                <VenueApprovalViewPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* testing */}
      <Route
        path="/registration/view/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration"
                onNavigate={handleNavigate}
              >
                <TORegistrationReviewPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* <Route
        path="/registration/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration"
                onNavigate={handleNavigate}
              >
                <TORegistrationReviewPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      /> */}

      {/* REGISTRATION VIEW ROUTE*/}
      <Route
        path="/registration/to-renewal-list"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration/list"
                onNavigate={handleNavigate}
              >
                <TORegistrationRenewalList onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/registration/renewal-details/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration/list"
                onNavigate={handleNavigate}
              >
                <RenewalApprovalDetailsPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/registration/block-users"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="registration/list"
                onNavigate={handleNavigate}
              >
                <BlockUsersMasterPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* ---------- Public Routes ---------- */}
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordPage onBackToLogin={() => navigate("/")} />}
      />

      <Route
        path="/to-registration"
        element={<TORegistrationPage onBack={() => navigate("/")} />}
        // element={<TORegistrationPage onBack={function (): void {
        //     throw new Error("Function not implemented.");
        // } }  />}
      />

      {/* ---------- Protected Routes ---------- */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage={currentPage}
              onNavigate={handleNavigate}
            >
              <DashboardPage />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/to-registration"
        element={<TORegistrationPage onBack={() => navigate("/")} />}
        // element={<TORegistrationPage onBack={function (): void {
        //     throw new Error("Function not implemented.");
        // } }  />}
      />

      {/* ---------- Protected Routes ---------- */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage={currentPage}
              onNavigate={handleNavigate}
            >
              <DashboardPage />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/receipts"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="receipts"
                onNavigate={handleNavigate}
              >
                <MannatNiyazReceiptPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/mtnz-dashboard"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="mtnz-dashboard"
                onNavigate={handleNavigate}
              >
                <MannatNiyazDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/mtnz-dashboard-approval"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="mtnz-dashboard-approval"
                onNavigate={handleNavigate}
              >
                <MannatNiyazDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* ✅ Fixed: Role Management (kebab-case path) */}
      <Route
        path="/role-management"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="role-management"
                onNavigate={handleNavigate}
              >
                <RoleManagementPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/user-management"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="user-management"
                onNavigate={handleNavigate}
              >
                <UserManagementPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/request-user"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="request-user"
                onNavigate={handleNavigate}
              >
                <RequestUserPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/email-config"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="email-config"
              onNavigate={handleNavigate}
            >
              <EmailConfigPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/port-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="port-master"
                onNavigate={handleNavigate}
              >
                <PortMasterListPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/port-master/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="port-master"
                onNavigate={handleNavigate}
              >
                <PortMasterFormPage
                  onBack={() => handleNavigate("port-master")}
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/port-master/:publicId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="port-master"
                onNavigate={handleNavigate}
              >
                <PortMasterFormPage
                  onBack={() => handleNavigate("port-master")}
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/lawazim-type-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="lawazim-type-master"
                onNavigate={handleNavigate}
              >
                <LawazimTypeMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/miqaat-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="miqaat-master"
                onNavigate={handleNavigate}
              >
                <MiqaatConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/miqaat-master/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="miqaat-master"
                onNavigate={handleNavigate}
              >
                <AddMiqaatConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/miqaat-master/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="miqaat-master"
                onNavigate={handleNavigate}
              >
                <EditMiqaatConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-type-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-type-master"
                onNavigate={handleNavigate}
              >
                <PropertyTypeGradeMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-grade-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-grade-master"
                onNavigate={handleNavigate}
              >
                <PropertyGradeMaster />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/amenities-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="amenities-master"
                onNavigate={handleNavigate}
              >
                <RoomAmenitiesMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/room-type-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="room-type-master"
                onNavigate={handleNavigate}
              >
                <RoomTypeMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-details"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-details"
                onNavigate={handleNavigate}
              >
                <PropertyDetailsMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-details/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-details"
                onNavigate={handleNavigate}
              >
                <AddPropertyPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-details/edit/:publicId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-details"
                onNavigate={handleNavigate}
              >
                <AddPropertyPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/currency-head"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="currency-head"
                onNavigate={handleNavigate}
              >
                <CurrencyHeadMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/buffer-configuration"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="buffer-configuration"
                onNavigate={handleNavigate}
              >
                <BufferConfigurationMaster />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/lawazim-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="lawazim-master"
                onNavigate={handleNavigate}
              >
                <LawazimConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/lawazim-master/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="lawazim-master"
                onNavigate={handleNavigate}
              >
                <AddLawazimConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/lawazim-master/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="lawazim-master"
                onNavigate={handleNavigate}
              >
                <EditLawazimConfiguration />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/ziyarat"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="ziyarat"
                onNavigate={handleNavigate}
              >
                <ZiyaratPlacesMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/atraaf"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="atraaf"
                onNavigate={handleNavigate}
              >
                <ZiyaratAtraafRoutesMaster />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/atraaf/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="atraaf"
                onNavigate={handleNavigate}
              >
                <CreateZiyaratAtraafRoutePage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/atraaf/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="atraaf"
                onNavigate={handleNavigate}
              >
                <EditZiyaratAtraafRoutePage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/atraaf-route-planner"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="atraaf-route-planner"
                onNavigate={handleNavigate}
              >
                <AtraafRoutePlannerPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tour-operator-type"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tour-operator-type"
                onNavigate={handleNavigate}
              >
                <TourOperatorType />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/cutoff-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="cutoff-master"
                onNavigate={handleNavigate}
              >
                <CutoffMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/cutoff-master/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="cutoff-master"
                onNavigate={handleNavigate}
              >
                <CutoffMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/warehouse-master"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="warehouse-master"
              onNavigate={handleNavigate}
            >
              <WarehouseMasterPage />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/tours"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <TourListPageEnhanced onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/tour-create"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <CreateTourMiqqaatPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/create-dashboard"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <TourCreationDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/tour-view-edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <TourViewEditPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/tour-approval/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <TourApprovalView />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/tour-recommend-changes/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <TourRecommendChanges />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/tours/tour-create/instant"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tours"
                onNavigate={handleNavigate}
              >
                <InstantBookingTourPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/walkin-tour"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="walkin-tour"
                onNavigate={handleNavigate}
              >
                <WalkinTourListPageEnhanced />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/walkin-tour/create"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="walkin-tour"
                onNavigate={handleNavigate}
              >
                <WalkInTourCreatePage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/walkin-tour/tour-view-edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="walkin-tour"
                onNavigate={handleNavigate}
              >
                <WalkInTourViewEditPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/vendor-dashboard"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="vendor-dashboard"
                onNavigate={handleNavigate}
              >
                <VendorDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-type"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-type"
                onNavigate={handleNavigate}
              >
                <EmployeeTypesPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-grade"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-grade"
                onNavigate={handleNavigate}
              >
                <EmployeeGradesPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employment-status"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employment-status"
                onNavigate={handleNavigate}
              >
                <EmploymentStatusPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/booking-receipts"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="booking-receipts"
                onNavigate={handleNavigate}
              >
                <BookingReceiptListPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/booking-receipts/create"
        element={
          <ProtectedLayout>
            <PermissionRoute requiredAction="add">
              <DashboardLayoutNew
                currentPage="booking-receipts"
                onNavigate={handleNavigate}
              >
                <BookingReceiptFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/booking-receipts/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute requiredAction="edit">
              <DashboardLayoutNew
                currentPage="booking-receipts"
                onNavigate={handleNavigate}
              >
                <BookingReceiptFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/mawaid-menu-calendar"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="mawaid-menu-calendar"
                onNavigate={handleNavigate}
              >
                <MenuCalendarPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/transport/vehicle-types"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="transport/vehicle-types"
                onNavigate={handleNavigate}
              >
                <VehicleTypeMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/transport/vehicles"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="transport/vehicles"
                onNavigate={handleNavigate}
              >
                <VehicleMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/transport/vendors"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="transport/vendors"
                onNavigate={handleNavigate}
              >
                <VendorMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/transport"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="transport"
                onNavigate={handleNavigate}
              >
                <TransportDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/intercity-checkout"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="intercity-checkout"
                onNavigate={handleNavigate}
              >
                <IntercityCheckoutPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-management"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-management"
                onNavigate={handleNavigate}
              >
                <EmployeeListPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-management/form"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-management"
                onNavigate={handleNavigate}
              >
                <EmployeeFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-management/view/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-management"
                onNavigate={handleNavigate}
              >
                <EmployeeFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/employee-management/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="employee-management"
                onNavigate={handleNavigate}
              >
                <EmployeeFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/salary-head"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="salary-head"
                onNavigate={handleNavigate}
              >
                <SalaryHeadsPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/department"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="department"
                onNavigate={handleNavigate}
              >
                <ManageDepartmentPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/designation"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="designation"
                onNavigate={handleNavigate}
              >
                <DesignationMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/workflow-master"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="workflow-master"
              onNavigate={handleNavigate}
            >
              <WorkflowMasterPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/property-availability"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <PropertyAvailabilityMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-availability/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <AvailabilityAdd />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-availability/edit/:publicId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <AvailabilityEdit />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-availability/block"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <PropertyAvailabilityMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-availability/block/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <BlockPropertyAdd />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/property-availability/block/edit/:publicId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="property-availability"
                onNavigate={handleNavigate}
              >
                <BlockPropertyEdit />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* <Route
        path="/tour-approvalpage"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="tour-approvalpage"
              onNavigate={handleNavigate}
            >
              <TourApprovalView />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      /> */}

      <Route
        path="/nationality-master"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="nationality-master"
              onNavigate={handleNavigate}
            >
              <NationalityMasterPage />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/to-ledger"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="to-ledger"
                onNavigate={handleNavigate}
              >
                <TOLedgerWalletFinance
                  onNavigate={handleNavigate}
                  viewMode="ledger-only"
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* TOUR REGISTRATION ROUTES */}

      <Route
        path="/my-wallet"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="my-wallet"
                onNavigate={handleNavigate}
              >
                <TOLedgerWalletFinance
                  onNavigate={handleNavigate}
                  viewMode="wallet-only"
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-applicant-management"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-applicant-management"
                onNavigate={handleNavigate}
              >
                <VisaApplicantManagementPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />
      <Route
        path="/visa-applicant-management/add"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-applicant-management"
                onNavigate={handleNavigate}
              >
                <VisaApplicantAddPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-applicant-management/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-applicant-management"
                onNavigate={handleNavigate}
              >
                <VisaApplicantEditPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-applicant/view/:id"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="visa-applicant-management"
              onNavigate={handleNavigate}
            >
              <VisaApplicantViewPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/visa-applicant-more-info-view/:id"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="visa-applicant-management"
              onNavigate={handleNavigate}
            >
              <VisaApplicantMoreInfoViewPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      <Route
        path="/visa-muwafiqa"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-muwafiqa"
                onNavigate={handleNavigate}
              >
                <EnhancedMuwafiqaProcessingPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* ✅ Receipt View Page (no sidebar highlight) */}
      <Route
        path="/visa-applicant-more-info-view/:id"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew
              currentPage="visa-applicant-management"
              onNavigate={handleNavigate}
            >
              <VisaApplicantMoreInfoViewPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      />

      {/* ✅ Receipt View Page (no sidebar highlight) */}
      {/* <Route
        path="/receipts/view"
        element={
          <ProtectedRoute>
            <DashboardLayoutNew currentPage="receipts" onNavigate={handleNavigate}>
              <MannatNiyazReceiptViewPage onNavigate={handleNavigate} />
            </DashboardLayoutNew>
          </ProtectedRoute>
        }
      /> */}

      <Route
        path="/country-city-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="country-city-master"
                onNavigate={handleNavigate}
              >
                <CountryCityMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/general-configuration"
        element={
          // <ProtectedRoute>
          //   <DashboardLayoutNew
          //     currentPage="general-configuration"
          //     onNavigate={handleNavigate}
          //   >
          //     <GeneralMasterPage />
          //   </DashboardLayoutNew>
          // </ProtectedRoute>

          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="general-configuration"
                onNavigate={handleNavigate}
              >
                <GeneralMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/document-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="document-master"
                onNavigate={handleNavigate}
              >
                <DocumentMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/document-template-master/add"
        element={
          <ProtectedLayout>
            <DashboardLayoutNew
              currentPage="document-template-master"
              onNavigate={handleNavigate}
            >
              <DocumentTemplateFormPage mode="add" />
            </DashboardLayoutNew>
          </ProtectedLayout>
        }
      />

      <Route
        path="/document-template-master/edit"
        element={
          <ProtectedLayout>
            <DashboardLayoutNew
              currentPage="document-template-master"
              onNavigate={handleNavigate}
            >
              <DocumentTemplateFormPage mode="edit" />
            </DashboardLayoutNew>
          </ProtectedLayout>
        }
      />

      <Route
        path="/document-template-master"
        element={
          <ProtectedLayout>
            {/* <PermissionRoute> */}
            <DashboardLayoutNew
              currentPage="document-template-master"
              onNavigate={handleNavigate}
            >
              <DocumentTemplateMasterPage />
            </DashboardLayoutNew>
            {/* </PermissionRoute> */}
          </ProtectedLayout>
        }
      />

      <Route
        path="/tour-service-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="tour-service-master"
                onNavigate={handleNavigate}
              >
                <TourServiceMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/advance-receipts"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="advance-receipts"
                onNavigate={handleNavigate}
              >
                <AdvanceReceiptListPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/advance-receipts/create"
        element={
          <ProtectedLayout>
            <PermissionRoute requiredAction="add">
              <DashboardLayoutNew
                currentPage="advance-receipts"
                onNavigate={handleNavigate}
              >
                <AdvanceReceiptFormPage
                  onNavigate={handleNavigate}
                  mode="create"
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/advance-receipts/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute requiredAction="edit">
              <DashboardLayoutNew
                currentPage="advance-receipts"
                onNavigate={handleNavigate}
              >
                <AdvanceReceiptFormPage
                  onNavigate={handleNavigate}
                  mode="edit"
                />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/age-rule-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="age-rule-master"
                onNavigate={handleNavigate}
              >
                <AgeRuleMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/venue-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="venue-master"
                onNavigate={handleNavigate}
              >
                <VenueMasterEnhanced />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-fee-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-fee-master"
                onNavigate={handleNavigate}
              >
                <VisaFeeMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/currency-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="currency-master"
                onNavigate={handleNavigate}
              >
                <CurrencyMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/mawaid-dashboard"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="mawaid-dashboard"
                onNavigate={handleNavigate}
              >
                <MawaidDashboardPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/mawaid-menu-master"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="mawaid-menu-master"
                onNavigate={handleNavigate}
              >
                <MenuMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-muwafiqa/completed"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-muwafiqa"
                onNavigate={handleNavigate}
              >
                <CompletedListPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-muwafiqa/completed/view"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-muwafiqa"
                onNavigate={handleNavigate}
              >
                <CompletedApplicationViewPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-muwafiqa/visa-document-required"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-muwafiqa"
                onNavigate={handleNavigate}
              >
                <VisaRequestedPageNew onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/visa-muwafiqa/visa-document-required/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="visa-muwafiqa"
                onNavigate={handleNavigate}
              >
                <VisaApplicantDetailPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/leave-type"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="leave-type"
                onNavigate={handleNavigate}
              >
                <LeaveTypeMasterPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/leave-policies"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="/leave-policies"
                onNavigate={handleNavigate}
              >
                <LeaveStructuresPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/leave-policies/new"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="hr-leave-structures"
                onNavigate={handleNavigate}
              >
                <LeavePolicyDetailsPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/leave-policies/:policyId"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="hr-leave-structures"
                onNavigate={handleNavigate}
              >
                <LeavePolicyDetailsPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/holidays"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="holidays"
                onNavigate={handleNavigate}
              >
                <HolidaysMasterPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/attendance"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="attendance"
                onNavigate={handleNavigate}
              >
                <AttendancePage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/payroll"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="payroll"
                onNavigate={handleNavigate}
              >
                <PayrollPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/qardan-type"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qardan-type"
                onNavigate={handleNavigate}
              >
                <QarzanHassanaPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/qardan-policies"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qardan-policies"
                onNavigate={handleNavigate}
              >
                <QardanPolicyPage />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/qardan-application"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qardan-application"
                onNavigate={handleNavigate}
              >
                <QarzLoanRegisterPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/qardan-application/create"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qardan-application"
                onNavigate={handleNavigate}
              >
                <QarzanHasanaFormPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/qardan-application/edit/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qardan-application"
                onNavigate={handleNavigate}
              >
                <QarzanHasanaFormEditPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/my-registration"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qarzan-hassana"
                onNavigate={handleNavigate}
              >
                <TORegistrationDashboardPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/my-registration/view/:id"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="qarzan-hassana"
                onNavigate={handleNavigate}
              >
                <MyRegistrationReviewPage onNavigate={handleNavigate} />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      {/* accommodation routes */}
      <Route
        path="/accommodation"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="accommodation"
                onNavigate={handleNavigate}
              >
                <AccommodationDashboardEnhanced />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />
      <Route
        path="/accommodation-reports"
        element={
          <DashboardLayoutNew
            currentPage="accommodation-reports"
            onNavigate={handleNavigate}
          >
            <AccommodationReportsPage />
          </DashboardLayoutNew>
        }
      />

      <Route
        path="/accommodation/reports/daily-checkin"
        element={
          <ProtectedLayout>
            <PermissionRoute>
              <DashboardLayoutNew
                currentPage="accommodation/reports/daily-checkin"
                onNavigate={handleNavigate}
              >
                <AccommodationReportsCheckInPage initialReport="occupancy" />
              </DashboardLayoutNew>
            </PermissionRoute>
          </ProtectedLayout>
        }
      />

      <Route
        path="/accommodation/luggage-tags"
        element={
          <DashboardLayoutNew
            currentPage="/accommodation/luggage-tags"
            onNavigate={handleNavigate}
          >
            <LuggageTagAutomationPage />
          </DashboardLayoutNew>
        }
      />
      {/* accommodation routes */}

      {/* ---------- Fallback ---------- */}
      {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
      <Route
        path="*"
        element={
          isAuthenticated ? (
            <ProtectedRoute>
              <DashboardLayoutNew currentPage="" onNavigate={handleNavigate}>
                <NotFoundPage />
              </DashboardLayoutNew>
            </ProtectedRoute>
          ) : (
            <NotFoundPage />
          )
        }
      />
    </Routes>
  );
};

export default AppRoutes;
